import { http } from "msw";

import { withSession } from "@/mocks/resolvers";
import { errorResponse, successResponse } from "@/mocks/responses";

export const createProgressHandlers = (webappUrl: string) => {
  return [
    http.get(
      `${webappUrl}/progress`,
      withSession(({ state }) => {
        if (!state.progress) {
          return errorResponse({
            status: 404,
            code: "progress_not_found",
            message: "Progress is not available for this care plan yet.",
          });
        }

        return successResponse(state.progress);
      }),
    ),
  ];
};
